export const themes = {
    apple_light: {
        name: "Apple Light",
        type: "light",
        colors: {
            background: "#F5F5F7",
            surface: "#FFFFFF",
            text: "#1D1D1F",
            secondary: "#86868B",
            accent: "#0A84FF",
            border: "#D1D1D6",
            hover: "#E5E5E5"
        }
    },
    apple_dark: {
        name: "Apple Dark",
        type: "dark",
        colors: {
            background: "#000000",
            surface: "#1C1C1E",
            text: "#F5F5F7",
            secondary: "#86868B",
            accent: "#0A84FF",
            border: "#38383A",
            hover: "#2C2C2E"
        }
    },
    rustic_charm: {
        name: "Rustic Charm",
        type: "light",
        colors: {
            background: "#fffcf2",
            surface: "#ccc5b9",
            text: "#252422",
            secondary: "#403d39",
            accent: "#eb5e28",
            border: "#9a958e",
            hover: "#b8b2a7"
        }
    },
    neutral_elegance: {
        name: "Neutral Elegance",
        type: "light",
        colors: {
            background: "#f4f3ee",
            surface: "#ffffff",
            text: "#463f3a",
            secondary: "#8a817c",
            accent: "#e0afa0",
            border: "#bcb8b1",
            hover: "#e0ded9"
        }
    },
    soft_lavender: {
        name: "Soft Lavender",
        type: "dark",
        colors: {
            background: "#22223b",
            surface: "#4a4e69",
            text: "#f2e9e4",
            secondary: "#9a8c98",
            accent: "#c9ada7",
            border: "#6b708d",
            hover: "#5c6085"
        }
    },
    cool_coastal: {
        name: "Cool Coastal",
        type: "light",
        colors: {
            background: "#edf2f4",
            surface: "#ffffff",
            text: "#2b2d42",
            secondary: "#8d99ae",
            accent: "#ef233c",
            border: "#dcdfe6",
            hover: "#f5f7f9"
        }
    },
    coastal_vibes_dark: {
        name: "Coastal Vibes (Dark)",
        type: "dark",
        colors: {
            background: "#293241",
            surface: "#3d5a80",
            text: "#e0fbfc",
            secondary: "#98c1d9",
            accent: "#ee6c4d",
            border: "#4a5d73",
            hover: "#49688e"
        }
    },
    summer_ocean: {
        name: "Summer Breeze",
        type: "light",
        colors: {
            background: "#f1faee",
            surface: "#ffffff",
            text: "#1d3557",
            secondary: "#457b9d",
            accent: "#e63946",
            border: "#a8dadc",
            hover: "#dceef0"
        }
    },
    fiery_ocean: {
        name: "Fiery Ocean",
        type: "light",
        colors: {
            background: "#fdf0d5",
            surface: "#ffffff",
            text: "#003049",
            secondary: "#669bbc",
            accent: "#c1121f",
            border: "#e5d8b0",
            hover: "#f0e6c8"
        }
    },
    monochrome_harmony: {
        name: "Monochrome Harmony",
        type: "light",
        colors: {
            background: "#e8eddf",
            surface: "#cfdbd5",
            text: "#242423",
            secondary: "#333533",
            accent: "#f5cb5c",
            border: "#b5c1bb",
            hover: "#dbe3d6"
        }
    },
    ocean_sunset: {
        name: "Ocean Sunset",
        type: "dark",
        colors: {
            background: "#001427",
            surface: "#1d2d3d",
            text: "#f4d58d",
            secondary: "#708d81",
            accent: "#bf0603",
            border: "#243b4d",
            hover: "#2a4258"
        }
    },
    minimalist_elegance: {
        name: "Minimalist Elegance",
        type: "dark",
        colors: {
            background: "#2d3142",
            surface: "#4f5d75",
            text: "#ffffff",
            secondary: "#bfc0c0",
            accent: "#ef8354",
            border: "#5c6b8a",
            hover: "#5f7191"
        }
    },
    vintage_coffee: {
        name: "Vintage Coffee",
        type: "light",
        colors: {
            background: "#f7f3e3",
            surface: "#ffffff",
            text: "#171a21",
            secondary: "#6f1a07",
            accent: "#ae9063",
            border: "#b3b6b7",
            hover: "#ece8d4"
        }
    },
    deep_space: {
        name: "Deep Space",
        type: "dark",
        colors: {
            background: "#000000",
            surface: "#0c1821",
            text: "#ccc9dc",
            secondary: "#324a5f",
            accent: "#1b2a41",
            border: "#1f2f40",
            hover: "#13232f"
        }
    },
    spring_garden: {
        name: "Spring Garden",
        type: "light",
        colors: {
            background: "#ebf8b8",
            surface: "#ffffff",
            text: "#7c6c77",
            secondary: "#aaa694",
            accent: "#ffe787",
            border: "#d1d0a3",
            hover: "#e1eca2"
        }
    },
    midnight_gold: {
        name: "Midnight Gold",
        type: "dark",
        colors: {
            background: "#101010",
            surface: "#14213d",
            text: "#ffffff",
            secondary: "#e5e5e5",
            accent: "#fca311",
            border: "#2a3b5e",
            hover: "#1f3259"
        }
    }
};
